export default __webpack_public_path__ + "static/media/logo-dark.bebae81c.png";